const footerTranslations = {
  en: {
    location: "Website",
    call: "📱 +91 62837 90049 (WhatsApp)",
    email: "✉️ akaalkids@gmail.com",
    copyright: "© 2026 All Rights Reserved. Distribution by ",
    akaalKids: "AKAAL KIDS",
    designedBy: "Designed by ",
    webenit: "WEBNIT",
  },
  pa: {
    location: "ਵੈੱਬਸਾਈਟ",
    call: "📱 +91 62837 90049 (ਵਟਸਐਪ)",
    email: "✉️ akaalkids@gmail.com",
    copyright: "© 2026 ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ। ਵੰਡ: ",
    akaalKids: "ਅਕਾਲ ਕਿਡਜ਼",
    designedBy: "ਡਿਜ਼ਾਈਨ ਕੀਤਾ: ",
    webenit: "ਵੇਬਨਿਟ",
  },
};

export default footerTranslations;
